import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter, Route, Switch, Redirect } from "react-router-dom";
import HomeV1 from './components/home-v1';
import HomeV2 from './components/home-v2';
import HomeV3 from './components/home-v3';
import HomeV4 from './components/home-v4';
import About from './components/about';
import Service from './components/service';
import ServiceV2 from './components/service-v2';
import ServiceDetails from './components/service-details';
import VoiceAiCalling from './components/voice-ai';
import LeadGeneration from './components/lead-generation';
import SocialMedia from './components/social-media-chatbot';
import RealTimeDashboard from './components/real-time-dashboard';
import EffortlessSetupIntegration from './components/effortless-setup-integration';
import AccurateIntelligenResponses from './components/accurate-intelligent-responses';
import SmartLeadCaptureConversion from './components/smart-lead-capture-conversion';
import ScalableBusinessPerformance from './components/scalable-business-performance';
import PortfolioStandard from './components/portfolio-standard';
import PortfolioFull from './components/portfolio-full';
import PortfolioMasonary from './components/portfolio-masonary';
import PortfolioDetails from './components/portfolio-details';
import Pricing from './components/pricing';
import Faq from './components/faq';
import Testimonial from './components/testimonial';
import Team from './components/team';
import BlogGrid from './components/blog-grid';
import BlogList from './components/blog-list';
import BlogDetails from './components/blog-details';
import Contact from './components/contact';
import Inquiry from './components/inquiry';
import Demo from './components/demo';
import PrivacyPolicy from './components/privacy-policy';
import TermsAndConditions from './components/terms-and-conditions';
import RefundAndCancellationPolicy from './components/refund-and-cancellation-policy';

class Root extends Component {
    render() {
        return(
                <Router basename="/">
	                <div>
	                <Switch>
	                    <Route exact path="/" component={HomeV3} />
	                    {/*<Route exact path="/home-v2" component={HomeV2} />*/}
	                    {/*<Route exact path="/home-v3" component={HomeV3} />*/}
	                    {/*<Route exact path="/home-v4" component={HomeV4} />*/}
	                    <Route path="/about" component={About} />
	                    <Route path="/service" component={Service} />
	                    <Route path="/service-v2" component={ServiceV2} />
	                    <Route path="/service-details" component={ServiceDetails} />
	                    <Route path="/voice-ai-calling-system" component={VoiceAiCalling} />
	                    <Route path="/lead-generation-automation" component={LeadGeneration} />
	                    <Route path="/social-media-chatbot-integration" component={SocialMedia} />
	                    <Route path="/real-time-dashboard-analytics" component={RealTimeDashboard} />
	                    <Route path="/effortless-setup-integration" component={EffortlessSetupIntegration} />
	                    <Route path="/accurate-intelligent-responses" component={AccurateIntelligenResponses} />
	                    <Route path="/smart-lead-capture-conversion" component={SmartLeadCaptureConversion} />
	                    <Route path="/scalable-business-performance" component={ScalableBusinessPerformance} />
	                    <Route path="/portfolio-standard" component={PortfolioStandard} />
	                    <Route path="/portfolio-full" component={PortfolioFull} />
	                    <Route path="/portfolio-masonary" component={PortfolioMasonary} />
	                    <Route path="/portfolio-details" component={PortfolioDetails} />
	                    <Route path="/pricing" component={Pricing} />
	                    <Route path="/faq" component={Faq} />
	                    <Route path="/testimonial" component={Testimonial} />
	                    <Route path="/team" component={Team} />
	                    <Route path="/blog-grid" component={BlogGrid} />
	                    <Route path="/blog-list" component={BlogList} />
	                    <Route path="/blog-details" component={BlogDetails} />
	                    <Route path="/contact" component={Contact} />
	                    <Route path="/inquiry" component={Inquiry} />
	                    <Route path="/demo" component={Demo} />
	                    <Route path="/privacy-policy" component={PrivacyPolicy} />
	                    <Route path="/terms-and-conditions" component={TermsAndConditions} />
	                    <Redirect from="/terms-of-service" to="/terms-and-conditions" />
	                    <Route path="/refund-and-cancellation-policy" component={RefundAndCancellationPolicy} />
	                    <Redirect from="/cookie-policy" to="/refund-and-cancellation-policy" />
	                </Switch>
	                </div>
                </Router>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('bizkar'));
